(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[836],{

/***/ 3863:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[...args]",
      function () {
        return __webpack_require__(59843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useStoreEmails; }
/* harmony export */ });
/* harmony import */ var _hooks_store_useStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8480);

function useStoreEmails(type) {
    var ref;
    var store = (0,_hooks_store_useStore__WEBPACK_IMPORTED_MODULE_0__/* .useStore */ .o)();
    return (ref = store.emails) === null || ref === void 0 ? void 0 : ref[type];
}


/***/ }),

/***/ 59843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96888);
/* harmony import */ var _components_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8278);
/* harmony import */ var _components_ui_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89146);
/* harmony import */ var _components_ui_divider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98121);
/* harmony import */ var _hooks_store_useStoreEmails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45431);
/* harmony import */ var _utils_ga__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27550);
/* harmony import */ var _utils_stores__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33739);
/* harmony import */ var _utils_stores__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_utils_stores__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76843);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68856);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);














function EmptyPage(props) {
    var ref;
    var data = _utils_trpc__WEBPACK_IMPORTED_MODULE_8__/* .trpc.cmsBlocks.get.useQuery */ .S.cmsBlocks.get.useQuery({
        identifiers: [
            "unbxd-recs-empty-search"
        ]
    }).data;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$G)("common").t;
    var customerSupportEmail = (0,_hooks_store_useStoreEmails__WEBPACK_IMPORTED_MODULE_5__/* .useStoreEmails */ .M)("customer_support_email").sender_email;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full items-center justify-center pb-8 pt-8 align-middle",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_11___default()), {
                    src: _utils_stores__WEBPACK_IMPORTED_MODULE_7__.basePath + "/assets/images/sad_face.svg",
                    alt: t("error-heading"),
                    width: 60,
                    height: 60
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full items-center justify-center align-middle text-xl font-bold md:text-2xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: t("text-search-empty", {
                        title: props.query
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full items-center justify-center align-middle",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "pt-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xl font-bold",
                            children: "Tips:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "list-disc space-y-3.5 p-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: t("text-empty-search-1")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: t("text-empty-search-2")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: t("text-empty-search-3")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    children: [
                                        t("text-empty-search-4"),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "mailto:".concat(customerSupportEmail),
                                            children: customerSupportEmail
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "user-defined-cms-block unbxd-recs-empty-search w-full px-0 py-16",
                children: (data === null || data === void 0 ? void 0 : data[0]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagebuilder_pageBuilder__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    pagebuilder: (ref = data[0]) === null || ref === void 0 ? void 0 : ref.pagebuilder,
                    noWrapper: true
                })
            })
        ]
    });
}
var __N_SSG = true;
function SearchPage(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(function() {
        _utils_ga__WEBPACK_IMPORTED_MODULE_6__/* .gaClient.pushEvent */ .Il.pushEvent({
            event: "search",
            search_term: props.query
        });
    }, [
        props.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Search: " + props.query
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_divider__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "mb-0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_ui_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    props.isEmpty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EmptyPage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props)),
                    !props.isEmpty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_products__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "search",
                        title: props.query,
                        urlKey: props.query,
                        fetchKey: props.query,
                        breadcrumbs: [
                            {
                                name: "Search"
                            }, 
                        ],
                        requestId: props.requestId,
                        response: props.response,
                        facets: props.facets,
                        options: props.options
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [556,675,187,363,278,928,888,179], function() { return __webpack_exec__(3863); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);